export default "__VITE_ASSET__3650ccf7__"